import { TextField } from '@mui/material'
import React, { useState } from 'react'
import CompleteButton from 'src/components/shared/CompleteButton';
import Services from 'src/services/Services';

export default function SendPanic() {
    const [message, setMessage] = useState("");
    const [token] = useState(() => {
        const user = JSON.parse(localStorage.getItem('user'));
        return user?.token || '';
    });

    const sendPanic = () => {
        Services.SendPanic(token, message)
            .then((res) => {
                console.log(res.data, "Send Panic");
            })
            .catch((err) => console.log(err));
    }

    return (
        <div>
            <TextField
                label="Mesaj"
                variant="outlined"
                multiline
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                sx={{ width: '250px', height: '250px' }}
            />
            <CompleteButton label={"Gönder"} onClick={sendPanic} />
        </div>
    )
}
